import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {Helmet} from 'react-helmet';
import { setActivitiesOpen } from '../../../actions/create-action'
import { Link } from 'react-router-dom';

import Menu from '../../Navigation/Menu'
import { store } from '../../../store';

import Navigation from '../../Navigation/Navigation';
import Footer from '../../Footer/Footer';
import {Grid, Row, Col} from 'react-bootstrap';
const mapStateToProps = (state) => {
  let open = state.activities.open
  return {
    open: open,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
  }
}

class Privacy extends React.Component {
   constructor(props) {
      super()
      this.state = {
         visible:false,
         mouseOverbtn: false,
         clickInside: false,
      }
      this.myRef=null
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onMenu = this.onMenu.bind(this)
   }
   componentWillMount() {
      this.setState({visible: true})
   }
   componentWillLeave() {
      this.setState({visible: false})
   }
   componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }
   componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      return;
    }
    else if(!this.state.clickInside)
      this.props.onOpen('')
  }
  onMenu = () => {
    if(store.getState().activities.open === 'menu')
    this.props.onOpen('')
    else this.props.onOpen('menu')
  }
  onClickInside = () => {
  this.setState({clickInside: true})
  }
  onClickOutside = () => {
    this.setState({clickInside: false})
  }
   render(props) {
      return (
         <div className="container_home" ref={this.setWrapperRef}>
         <Helmet>
          <title>Privacy Policy</title>  
          <meta name="description" content="This Privacy Policy document contains types of information that is collected and recorded by vieww and how we use it." />
          <meta name="keyword" content="profile website, vieww profile, profiles, create onepage site" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://app.vieww.me/privacy-policy" />
          <meta property="og:title" content="Privacy Policy" />
          <meta name="og:description" content="This Privacy Policy document contains types of information that is collected and recorded by vieww and how we use it." />
          <meta property="og:site_name" content="Privacy Policy" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta name="robots" content="index, follow" />
         </Helmet>
         <Grid fluid={true} className="container_light">
         <Row>
         <Col lg={12} md={12} sm={12} xs={12}>
         <Navigation
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onMenu={this.onMenu}
            location={this.props.location}/>
         </Col>
         <Col lg={10} md={10} sm={10} xs={12} className="light_inside">
         <h1>Privacy Policy</h1>
<p>At vieww, accessible from <Link to={'/'}>vieww.me</Link>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by vieww and how we use it.</p>

<p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us through email at <strong><a href="mailto:hello@vieww.me">hello@vieww.me</a></strong></p>

<h3>Log Files</h3>

<p>vieww follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.</p>

<h3>Cookies and Web Beacons</h3>

<p>Like any other website, vieww uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.</p>

<h3>Privacy Policies</h3>

<p>You may consult this list to find the Privacy Policy for each of the advertising partners of vieww. Our Privacy Policy was created with the help of the GDPR Privacy Policy Generator and the Terms and Conditions Template.</p>

<p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on vieww, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>

<p>Note that vieww has no access to or control over these cookies that are used by third-party advertisers.</p>

<h3>Third Pary Privacy Policies</h3>

<p>vieww's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You may find a complete list of these Privacy Policies and their links here: Privacy Policy Links.</p>

<p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites. What Are Cookies?</p>

<h3>Children's Information</h3>

<p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>

<p>vieww does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>

<h3>Online Privacy Policy Only</h3>

<p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in vieww. This policy is not applicable to any information collected offline or via channels other than this website.</p>

<h3>Consent</h3>

<p>By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.</p>
         </Col>
         </Row>
         </Grid>
         <Footer  location={this.props.location} />
         {store.getState().activities.open === 'menu'
            ? <Menu
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onOpen={this.props.onOpen} />
            : null
          }
         </div>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);